import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
    catchError,
    Observable,
    switchMap,
    tap,
    throwError
} from 'rxjs';

import { environment } from '../../../../environments/environment';

import { LoginRequest } from '../models/login-request';
import { LoginResponse } from '../models/login-response';
import { MeResponse } from '../models/me-response';

import { SessionService } from './session.service';


@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private readonly http =
        inject(HttpClient);

    private readonly session =
        inject(SessionService);

    private readonly baseUrl =
        environment.identityApiUrl;


    login(
        request: LoginRequest,
        rememberMe: boolean
    ): Observable<MeResponse> {

        return this.http
            .post<LoginResponse>(
                `${this.baseUrl}/api/v1/auth/login`,
                request
            )
            .pipe(

                /*
                 * Guardamos JWT.
                 */
                tap(response => {

                    this.session.startSession(
                        response,
                        rememberMe
                    );

                }),

                /*
                 * Ahora usamos el JWT recién recibido
                 * para obtener roles y perfil real.
                 */
                switchMap(() =>
                    this.getMe()
                ),

                /*
                 * Guardamos perfil completo.
                 */
                tap(user => {

                    this.session.setUser(user);

                }),

                /*
                 * Si algo falla durante el proceso
                 * no dejamos una sesión incompleta.
                 */
                catchError(error => {

                    this.session.clear();

                    return throwError(
                        () => error
                    );

                })
            );
    }


    getMe(): Observable<MeResponse> {

        return this.http.get<MeResponse>(
            `${this.baseUrl}/api/v1/users/me`
        );
    }


    logout(): void {

        this.session.clear();
    }


    isAuthenticated(): boolean {

        return this.session.isAuthenticated();
    }


    getCurrentUser(): MeResponse | null {

        return this.session.getUser();
    }
}